import { render, staticRenderFns } from "./OspiNumberCard.vue?vue&type=template&id=a087c858&scoped=true&"
import script from "./OspiNumberCard.vue?vue&type=script&lang=js&"
export * from "./OspiNumberCard.vue?vue&type=script&lang=js&"
import style0 from "./OspiNumberCard.vue?vue&type=style&index=0&id=a087c858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a087c858",
  null
  
)

export default component.exports